<div [formGroup]="salesCycleGroup">
    <mat-horizontal-stepper labelPosition="bottom" [linear]="true" #stepper>
        <div *ngIf="(selectedOpp | json) != '{}' && salesCycles.length > 0 && salesCycleCheckLists.length > 0">
            <mat-step *ngFor="let salesCycle of salesCycles" formGroupName="{{salesCycle.abbrev}}">
                <ng-template matStepLabel>{{salesCycle.description}}</ng-template>

                <div class="row">
                    <div class="col-sm-6">
                        <h3>{{salesCycle.description}}</h3>
                    </div>
                    <div class="col" *ngIf="salesCycle.description == 'Finalist(50-75% win)' || salesCycle.description == 'Pre-Award (90%)'">
                        <!--<label class="text-danger">Please update the "Likelihood of Win" value in the Opportunity form.</label>-->
                        <label class="fw-bold text-danger">Likelihood of Win (eg. 0.6 for 60%)</label>
                        <div class="row">
                            <div class="col-sm-3">
                                <kendo-numerictextbox format="p" [step]="0.01" [min]="0" [max]="1" [value]="opportunity.likelihoodOfWin" [(ngModel)]="opportunity.likelihoodOfWin" [ngModelOptions]="{standalone: true}"></kendo-numerictextbox>
                            </div>
                            <div class="col-sm-1">
                                <button type="button" class="btn btn-primary" (click)="saveOpportunity()" [disabled]="isSaving"><i class="fas fa-check"></i></button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-4" *ngFor="let checkList of getCheckListBySalesCycleId(salesCycle.salesCycleId)">
                        <div class="col" *ngIf="salesCycleGroup.controls[salesCycle.abbrev] != null &&
                            salesCycleGroup.controls[salesCycle.abbrev].controls[checkList.stage + 'Checkbox'] != null">
                            <mat-checkbox formControlName="{{checkList.stage}}Checkbox" required (change)="saveChecklistMap(checkList)"></mat-checkbox>
                            <span style="padding-left:5px;">{{checkList.description}}</span>
                            <span>{{getCompletedChecklistTimestamp(checkList)}}</span>
                            <textarea formControlName="{{checkList.stage}}Text" (focusout)="saveChecklistMap(checkList)" class="form-control" rows="3" cols="50" placeholder="Enter Notes..."></textarea>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-2">
                        <button class="btn btn-secondary" mat-button matStepperPrevious>Back</button>
                    </div>
                    <div class="col-sm-4">
                        <mat-select placeholder="Sales Cycle" [(ngModel)]="newSalesCycleId" [ngModelOptions]="{standalone: true}">
                            <mat-option>--</mat-option>
                            <mat-option *ngFor="let salesCycle of allSalesCycles" [value]="salesCycle.salesCycleId">
                                {{salesCycle.description}}
                            </mat-option>
                        </mat-select>
                    </div>
                    <div class="col-sm-4">
                        <button class="btn btn-primary" mat-button (click)="updateSalesCycle()">Change Sales Cycle</button>
                    </div>
                    <div class="col-sm-2">
                        <button [disabled]="!isChecklistComplete(salesCycle)" class="btn btn-secondary" mat-button matStepperNext style="float: right; margin: 5px;">Next</button>
                    </div>
                </div>
            </mat-step>
            <mat-step>
                <ng-template matStepLabel>End of Cycle</ng-template>

                <div class="row" *ngFor="let salesCycle of endSalesCycles">
                    <div class="col-sm-12" *ngIf="salesCycle.salesCycleId == selectedOpp.salesCycleId">
                        <h3 class="text-center">{{salesCycle.description}}</h3>

                        <div class="row" formGroupName="{{salesCycle.abbrev}}">
                            <div class="col-sm-4" *ngFor="let checkList of getCheckListBySalesCycleId(salesCycle.salesCycleId)">
                                <div class="col" *ngIf="salesCycleGroup.controls[salesCycle.abbrev] != null &&
                            salesCycleGroup.controls[salesCycle.abbrev].controls[checkList.stage + 'Checkbox'] != null">
                                    <mat-checkbox formControlName="{{checkList.stage}}Checkbox" required (change)="saveChecklistMap(checkList)"></mat-checkbox>
                                    <span style="padding-left:5px;">{{checkList.description}}</span>
                                    <span>{{getCompletedChecklistTimestamp(checkList)}}</span>
                                    <textarea formControlName="{{checkList.stage}}Text" (focusout)="saveChecklistMap(checkList)" class="form-control" rows="3" cols="50" placeholder="Enter Notes..."></textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-2">
                        <button class="btn btn-secondary" mat-button matStepperPrevious>Back</button>
                    </div>
                    <div class="col-sm-4">
                        <mat-select placeholder="Sales Cycle" [(ngModel)]="newSalesCycleId" [ngModelOptions]="{standalone: true}" (selectionChange)="getSalesCycle()">
                            <mat-option>--</mat-option>
                            <mat-option *ngFor="let salesCycle of endSalesCycles" [value]="salesCycle.salesCycleId">
                                {{salesCycle.description}}
                            </mat-option>
                        </mat-select>
                    </div>
                    <div class="col-sm-4">
                        <!--<button class="btn btn-primary" mat-button (click)="updateSalesCycle()">Change Sales Cycle</button>-->
                    </div>
                    <div class="col-sm-2">
                        <!--<button [disabled]="!isChecklistComplete(salesCycle)" class="btn btn-secondary" mat-button matStepperNext style="float: right; margin: 5px;">Next</button>-->
                    </div>
                </div>
            </mat-step>
        </div>
    </mat-horizontal-stepper>
</div>
